import {Component, Inject, Input, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-json-ld-schema',
    template: ''
})

export class JsonLdSchemaComponent implements OnInit {
    private static scriptElement: any;

    @Input() schemaData: any;

    constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: any) {
    }

    ngOnInit(): void {
        if (JsonLdSchemaComponent.scriptElement) {
            this.renderer.removeChild(this.document.body, JsonLdSchemaComponent.scriptElement);
        }

        JsonLdSchemaComponent.scriptElement = this.renderer.createElement('script');
        JsonLdSchemaComponent.scriptElement.type = `application/ld+json`;
        JsonLdSchemaComponent.scriptElement.text = this.schemaData;

        this.renderer.appendChild(this.document.body, JsonLdSchemaComponent.scriptElement);
    }
}